import { Text } from '@chakra-ui/react'
import React from 'react'

import { ConfirmDialog } from '@mangovoice/mango-ui'

import type { SwitchboardTranslateFn } from '../../types'
import { text } from '../../utils/text'

export interface DeleteEdgeConfirmationDialogProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  t?: SwitchboardTranslateFn
}

/**
 * Confirmation dialog for deleting an edge (connection)
 */
export const DeleteEdgeConfirmationDialog: React.FC<
  DeleteEdgeConfirmationDialogProps
> = ({ isOpen, onConfirm, onCancel, t }) => {
  const bodyText = text(
    t,
    'switchboard.dialogs.deleteEdge.body',
    'Are you sure you want to delete this connection?',
  )

  const warningText = text(
    t,
    'switchboard.dialogs.deleteEdge.warning',
    'This action cannot be undone.',
  )

  return (
    <ConfirmDialog
      open={isOpen}
      onClose={onCancel}
      title={text(
        t,
        'switchboard.dialogs.deleteEdge.title',
        'Delete Connection',
      )}
      description={bodyText}
      confirmLabel={text(t, 'switchboard.dialogs.deleteEdge.confirm', 'Delete')}
      cancelLabel={text(t, 'switchboard.dialogs.deleteEdge.cancel', 'Cancel')}
      onConfirm={onConfirm}
      variant="destructive"
    >
      <Text fontSize="sm" color="fg.muted" lineHeight="1.5" mt={2}>
        {warningText}
      </Text>
    </ConfirmDialog>
  )
}
